var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPainPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5C11.8139 14.5 14.5 11.8133 14.5 8.5C14.5 5.18605 11.8139 2.5 8.5 2.5C5.18605 2.5 2.5 5.18605 2.5 8.5C2.5 11.8133 5.18605 14.5 8.5 14.5Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34619 6.50355V6.46918M6.31584 6.36719C6.23318 6.36719 6.16584 6.43452 6.16651 6.51719C6.16651 6.59985 6.23384 6.66719 6.31651 6.66719C6.39918 6.66719 6.46651 6.59985 6.46651 6.51719C6.46651 6.43385 6.39918 6.36719 6.31584 6.36719Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6538 6.50355V6.46918M10.6493 6.36719C10.5667 6.36719 10.4993 6.43452 10.5 6.51719C10.5 6.59985 10.5673 6.66719 10.65 6.66719C10.7327 6.66719 10.8 6.59985 10.8 6.51719C10.8 6.43385 10.7327 6.36719 10.6493 6.36719Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4118 11.1226C10.4118 9.98747 9.55563 9.06641 8.49963 9.06641C7.44363 9.06641 6.5874 9.98747 6.5874 11.1226H10.4118Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainPoints);
export default __webpack_public_path__ + "static/media/painPoints.1ce1435b052017ad601c384ce86f39c2.svg";
export { ForwardRef as ReactComponent };